import React from "react";

import { useTheme } from "@emotion/react";
import CustomSelectMenu, {
  CustomSelectMenuProps,
} from "@hl/base-components/lib/CustomSelectMenu";
import { SearchIcon } from "@hl/base-components/lib/assets/icons.generated";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { Box, Flex, Loader, TextInput } from "@mantine/core";
import { IconCircleX } from "@tabler/icons";
import useMantineMediaQueries from "~/../../base-components/lib/hooks/useMantineMediaQueries";

const SectionFilterResults = ({
  placeholderText,
  query,
  sort,
  sortOptions,
  onChangeQuery,
  onChangeSort,
  isLoading,
}: {
  placeholderText?: string;
  query?: string;
  sort?: string;
  sortOptions?: CustomSelectMenuProps["data"];
  onChangeQuery?: (value: string) => void;
  onChangeSort?: (value: string) => void;
  isLoading?: boolean;
}) => {
  const theme = useTheme();
  const { isMedium } = useMantineMediaQueries();

  return (
    <Box>
      <Flex direction={"row"} gap={12}>
        {onChangeQuery && (
          <TextInput
            size="md"
            mt={-8}
            sx={{ flex: 1 }}
            iconWidth={46}
            icon={
              <SearchIcon
                width={20}
                height={20}
                color={theme.fn.themeColor(TEXT_COLOR.PRIMARY)}
              />
            }
            placeholder={placeholderText || "Search by name, ID, or trait"}
            value={query}
            onChange={(e) => onChangeQuery(e.target.value)}
            rightSection={
              isLoading ? (
                <Loader size="xs" />
              ) : (
                query !== "" && (
                  <IconCircleX
                    style={{ cursor: "pointer" }}
                    onClick={() => onChangeQuery("")}
                  />
                )
              )
            }
          />
        )}

        {sort && sortOptions && onChangeSort && (
          <Box>
            <CustomSelectMenu
              value={sort}
              onChange={(value) => onChangeSort(value)}
              data={sortOptions}
              miw={isMedium ? undefined : 0}
              hideLabel={!isMedium}
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default SectionFilterResults;
